import { render, staticRenderFns } from "./PartnerTransaction.vue?vue&type=template&id=0ef152f7&scoped=true"
import script from "./PartnerTransaction.vue?vue&type=script&lang=ts"
export * from "./PartnerTransaction.vue?vue&type=script&lang=ts"
import style0 from "./PartnerTransaction.vue?vue&type=style&index=0&id=0ef152f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef152f7",
  null
  
)

export default component.exports